import { Resource } from "@entities/resources";
import {
  aspectRatioMap,
  iconTypeMap,
} from "@entities/resources/ui/card/config";
import { RichText } from "@shared/ui/rich-text";
import Image from "next/image";
import { forwardRef } from "react";

export type CardProps = {
  resource: Resource;
  className?: string;
};

export const Card = forwardRef<HTMLAnchorElement, CardProps>(function Card(
  {
    resource: { published_at, link, name, summary, platform, image },
    className,
  },
  ref
) {
  return (
    <a
      ref={ref}
      className={[
        "w-full flex flex-col bg-gray-100 rounded-md duration-500 hover:transition-all hover:opacity-70 hover:rounded-none overflow-clip cursor-pointer break-inside-avoid-column",
        className,
      ].join(" ")}
      href={link}
      target={"_blank"}
    >
      <div
        className={"relative w-full bg-gray-300"}
        style={{ aspectRatio: aspectRatioMap[platform] }}
      >
        <Image src={image} alt="Image" fill className="object-cover" />

        <div
          className={
            "absolute flex left-4 top-4 w-8 aspect-square bg-white border rounded-full items-center justify-center"
          }
        >
          {iconTypeMap[platform]({ className: "w-5 aspect-square" })}
        </div>
      </div>

      <div
        className={
          "h-full flex flex-col gap-4 p-8 border-t-4 border-antique-brass-500"
        }
      >
        <RichText className={"text-xl text-gray-700"} message={name} />

        <RichText className={"text-gray-700"} message={summary} />

        <div
          className={
            "flex-1 flex text-gray-700 w-full text-right text-sm font-light items-end justify-end"
          }
        >
          {published_at}
        </div>
      </div>
    </a>
  );
});
